import { useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";

export function useRefundStripeOrder() {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();

  const [loading, setLoading] = useState(false);
  const refundStripeOrder = async (
    orderId: string,
    partialAmountInCents?: number,
  ): Promise<void> => {
    const axiosInstance = createAxiosInstance();
    try {
      setLoading(true);
      await axiosInstance.post(`/admin/refund/`, {
        orderId,
        ...(partialAmountInCents && { amountToRefund: partialAmountInCents }),
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    refundStripeOrder,
    loading,
  };
}
